import styles from "./SettingsContactUsChatPage.module.css";
import { useSettingsContactUsChatViewModel } from "@/features/settings/viewModal/useSettingsContactUsChatViewModel";
import { Modal } from "@/shared/modal";

export const SettingsContactUsChatPage = () => {
  const {
    fileInputRef,
    sessionId,
    expandedImage,
    setExpandedImage,
    messages,
    textInputValue,
    imageUris,
    setTextInputValue,
    removeImage,
    onSend,
    onFileChange,
    loading,
    isOwnMessage,
  } = useSettingsContactUsChatViewModel();

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Support Chat</h1>

      <div className={styles.chatPanel}>
        <div className={styles.messages}>
          {messages.length === 0 && (
            <p className={styles.empty}>No messages yet. Start the conversation.</p>
          )}
          {messages.map((message) => (
            <div
              key={message._id}
              className={`${styles.messageRow} ${isOwnMessage(message.user?._id) ? styles.mine : styles.theirs}`.trim()}
            >
              <div className={styles.bubble}>
                {message.text && <p className={styles.messageText}>{message.text}</p>}
                {!!message.images?.length && (
                  <div className={styles.messageImages}>
                    {message.images.map((img) => (
                      <button
                        key={img}
                        type="button"
                        className={styles.previewTrigger}
                        onClick={() => setExpandedImage(img)}
                        aria-label="Expand image"
                      >
                        <img src={img} alt="attachment" className={styles.messageImage} />
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {!!imageUris.length && (
          <div className={styles.pendingImages}>
            {imageUris.map((img, index) => (
              <div key={`${img}-${index}`} className={styles.pendingItem}>
                <button
                  type="button"
                  className={styles.previewTrigger}
                  onClick={() => setExpandedImage(img)}
                  aria-label={`Expand pending image ${index + 1}`}
                >
                  <img src={img} alt={`pending ${index + 1}`} className={styles.pendingImg} />
                </button>
                <button
                  type="button"
                  className={styles.removeBtn}
                  onClick={() => removeImage(index)}
                >
                  x
                </button>
              </div>
            ))}
          </div>
        )}

        <div className={styles.composer}>
          <button
            type="button"
            className={styles.attachBtn}
            onClick={() => fileInputRef.current?.click()}
          >
            Attach
          </button>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept="image/*"
            hidden
            onChange={onFileChange}
          />
          <input
            value={textInputValue}
            onChange={(event) => setTextInputValue(event.target.value)}
            placeholder="Type your message..."
            className={styles.input}
          />
          <button
            type="button"
            className={styles.sendBtn}
            disabled={loading || !sessionId}
            onClick={() => void onSend()}
          >
            {loading ? "Sending..." : "Send"}
          </button>
        </div>
      </div>

      <Modal
        isOpen={expandedImage != null}
        onClose={() => setExpandedImage(null)}
        showCloseButton={false}
        hideBackdrop
        overlayClassName={styles.imageLightbox}
        unconstrained
        className={styles.lightboxPanel}
        bodyClassName={styles.lightboxPanelBody}
        ariaLabel="Expanded image preview"
      >
        <button
          type="button"
          className={styles.lightboxClose}
          aria-label="Close image preview"
          onClick={() => setExpandedImage(null)}
        >
          ×
        </button>
        {expandedImage ? (
          <img
            src={expandedImage}
            alt="Expanded attachment preview"
            className={styles.lightboxImage}
          />
        ) : null}
      </Modal>
    </div>
  );
};
